import { loadable } from '../../components/loadable';

export const LoadableThankYouPage = loadable(() => import('./ThankYouPage'), {
  key: 'HotConnectedThankYouPage',
});
